import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";


function Header() {
  const navigate = useNavigate(); // Hook for navigation
  const [searchQuery, setSearchQuery] = useState("");  // Store the input query
  const [searchResults, setSearchResults] = useState([]);  // Store search results
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); // Control visibility of dropdown
 // Create refs for the input field and the dropdown
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
 const token = window.localStorage.getItem("tokenfirst");

  const decodedToken = jwtDecode(token);

  // Handle input change
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.trim()) {
      fetchSearchResults(query);
    } else {
      setSearchResults([]);  // Clear results if query is empty
      setIsDropdownVisible(false);
    }
  };


  // Fetch search results from the backend
  const fetchSearchResults = async (query) => {
    try {
      const baseUrl =
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_BASE_URL_DEV
          : process.env.REACT_APP_BASE_URL_PROD;

      const response = await fetch(`${baseUrl}/adminbooking/global-search?q=${query}`);
      const data = await response.json();

      if (data.success && data.data) {
        // Filter results based on available data
        const filteredResults = filterSearchResults(query, data.data);
        setSearchResults(filteredResults); // Populate search results
        setIsDropdownVisible(true);  // Show the dropdown
      } else {
        setSearchResults([]); // No data returned from API, so clear results
        setIsDropdownVisible(false);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  // Function to detect the type of input and filter the search results
  const filterSearchResults = (query, results) => {
    const searchTerm = query.trim().toLowerCase();

    // Only include results that match the search term
    let filteredResults = [];

    // If searching for vendorId (email)
    if (searchTerm.includes('@')) {
      filteredResults = results.services.filter((result) => result.vendorId && result.vendorId.toLowerCase().includes(searchTerm));
    }
    // If it's numeric (bookingId)
    else if (!isNaN(searchTerm)) {
      filteredResults = results.bookings.filter((result) => result.bookingId && result.bookingId.toString().includes(searchTerm));
    }
    // Otherwise, show results based on serviceId
    else {
      filteredResults = results.services.filter((result) => result.serviceId && result.serviceId.toLowerCase().includes(searchTerm));
    }

    return filteredResults;
  };

  const handleSelectResult = (result) => {
    setSearchQuery(result.serviceId || result.vendorId || result.bookingId);  
    setIsDropdownVisible(false);  // Close the dropdown immediately after selection

    if (result.bookingId) {

      navigate(`/admin/booking/bookingview?id=${result.bookingId}&email=${result.email}`); // Navigate to booking view page
          setIsDropdownVisible(false);  // Close the dropdown immediately after selection

    } else if (result.vendorId) {
      navigate(`/admin/vendor/vendorveiw?id=${result.vendorId}`); // Navigate to vendor view page
          setIsDropdownVisible(false);  // Close the dropdown immediately after selection

    } else if (result.serviceId) {
      navigate(`/admin/services/viewservice?subId=${result.serviceId}&email=${result.email}`);
          setIsDropdownVisible(false);  // Close the dropdown immediately after selection
 // Navigate to service view page
    } else if (result.email) {
      navigate(`/admin/customer/viewcustomer?id=${result.email}`); // Navigate to customer view page
          setIsDropdownVisible(false);  // Close the dropdown immediately after selection

    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target) && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);  // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div className="h-[75px] lg:flex justify-between px-10 py-4 items-center border-b w-full hidden">
        <div className="relative w-1/3 ml-[260px]">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}  // Keep the search query exactly as typed by the user
            onChange={handleSearch}  // Handle changes in the input field
            onKeyDown={(e) => {
              if (e.key === "Enter" && searchResults.length > 0) {
                handleSelectResult(searchResults[0]);  // Select the first result on Enter
              }
            }}
            className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:border-[#27648B]"
          />
          {isDropdownVisible && searchQuery && (
            <div ref={dropdownRef} className="absolute bg-white w-full z-50 border rounded-lg shadow-md mt-2 max-h-[200px] overflow-y-auto">
              {searchResults.length > 0 ? (
                searchResults.map((result, index) => (
                  <div
                    key={index}
                    className="cursor-pointer p-2 hover:bg-gray-100"
                  >
                    {result.serviceId && (
                      <p
                        className="text-xs text-gray-500 cursor-pointer"
                        onClick={() => handleSelectResult(result)} // Reuse the handler
                      >
                        Service ID: {result.serviceId}
                      </p>
                    )}

                    {result.vendorId && (
                      <p
                        className="text-xs text-gray-500 cursor-pointer"
                        onClick={() => handleSelectResult(result)} // Reuse the handler
                      >
                        Vendor ID (Email): {result.vendorId}
                      </p>
                    )}

                    {result.bookingId && (
                      <p
                        className="text-xs text-gray-500 cursor-pointer"
                        onClick={() => handleSelectResult(result)} // Reuse the handler
                      >
                        Booking ID: {result.bookingId}
                      </p>
                    )}

                    {result.vendorName && (
                      <p className="text-xs text-gray-500">Vendor: {result.vendorName}</p>
                    )}

                    {result.serviceName && (
                      <p className="text-xs text-gray-500">Service: {result.serviceName}</p>
                    )}
                  </div>
                ))
              ) : (
                <div className="p-2 text-sm text-gray-500">No results found</div>
              )}
            </div>
          )}
        </div>

        <div className="flex gap-5 items-center">
          <button
            onClick={() => {
              localStorage.clear();
              window.location.href = "/";
            }}
            className="text-white text-[12px] md:text-[14px] mr-1 bg-[#27648B] hover:bg-[#27648B] px-2 rounded-xl h-[30px]"
          >
            Logout
          </button>

           <Link to={"/admin/notification"}>   <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_1840_7151"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1840_7151)">
              <path
                d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z"
                fill="#2A668D"
              />
            </g>
          </svg>
          </Link>

          <span className="h-14 w-14 rounded-full flex items-center gap-2 mr-4">
            <img
              src="/images/login.jpg"
              alt="User"
              className="w-10 h-10 rounded-full"
            />
            <p className="text-[#27648B] font-bold">{decodedToken.fullName}</p>
          </span>
        </div>
      </div>
    </>
  );
}

export default Header;
